<template>
	<div>
		<ModalApprovalTransfer ref="ModalApprovalTransfer" @action="approval"></ModalApprovalTransfer>
		<modalconfirm ref="modalconfirmTransfer" @action="confirmCancelTransfer"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'ecommerce-transfer-confirmation'">Data Transfer Bank</div>
			<div class="text-h5" v-else-if="$route.name == 'ecommerce-transfer-confirmation-cancel'">Pembatalan Konfirmasi Transfer</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listData" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationData.total_data" class="table-w-160">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom v-if="$route.name == 'ecommerce-transfer-confirmation'">
						<template v-slot:activator="{ on, attrs }">
							<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="approve(item.trx_id)" class="mr-2">
								<v-icon dark>mdi-check</v-icon>
							</v-btn>
						</template>
						<span>Konfirmasi</span>
					</v-tooltip>
					<v-tooltip bottom v-else-if="$route.name == 'ecommerce-transfer-confirmation-cancel'">
						<template v-slot:activator="{ on, attrs }">
							<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="cancelTransfer(item.trx_id)" class="mr-2">
								<v-icon dark>mdi-check</v-icon>
							</v-btn>
						</template>
						<span>Batalkan Konfirmasi</span>
					</v-tooltip>
				</template>
				<template v-slot:item.trx_payment_bank_input_datetime="{ item }">
					<div class="pt-2">{{item.trx_payment_bank_input_datetime | tanggaljam}}</div>
				</template>
				<template v-slot:item.stockist="{ item }">
					<div class="pt-2">{{item.stockist_code}} - {{item.stockist_network_mid}} - {{item.stockist_name}}</div>
				</template>
				<template v-slot:item.trx_payment_bank_to="{ item }">
					<div class="pt-2">{{item.trx_payment_bank_to_bank_account_no}} - {{item.trx_payment_bank_to_bank_account_name}}</div>
				</template>
				<template v-slot:item.trx_payment_bank_from="{ item }">
					<div class="pt-2">{{item.trx_payment_bank_from_bank_account_no}} - {{item.trx_payment_bank_from_bank_account_name}}</div>
				</template>
				<template v-slot:item.trx_payment_bank_transfer_value="{ item }">
					<div class="pt-2">{{item.trx_payment_bank_transfer_value | toRupiah}}</div>
				</template>
				<template v-slot:item.note="{ item }">
					<div class="pt-2" v-if="$route.name == 'ecommerce-transfer-confirmation'">{{item.trx_payment_bank_note}}</div>
					<div class="pt-2" v-else-if="$route.name == 'ecommerce-transfer-confirmation-cancel'">{{item.trx_payment_bank_administrator_note}}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationData">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationData">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationData.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationData.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalApprovalTransfer from './components/ModalApprovalTransfer'

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalApprovalTransfer
	},
	data() {
		return {
			trx_id: '',
			sortBy: 'trx_payment_bank_trx_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'center', value: 'action'},
			{ text: 'Kode Transaksi', align: 'start', value: 'trx_code'},
			{ text: 'Tanggal Input', align: 'start', value: 'trx_payment_bank_input_datetime'},
			{ text: 'Stockist', value: 'stockist', width: '17%', sortable: false },
			{ text: 'Bank Pengirim', value: 'trx_payment_bank_from_bank_name'},
			{ text: 'Rekening Pengirim', value: 'trx_payment_bank_from', sortable: false },
			{ text: 'Bank Tujuan', value: 'trx_payment_bank_to_bank_account_bank'},
			{ text: 'Rekening Tujuan', value: 'trx_payment_bank_to', sortable: false },
			{ text: 'Nominal', value: 'trx_payment_bank_transfer_value'},
			{ text: 'Keterangan', value: 'note'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Transaksi',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_code'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal Input',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'trx_payment_bank_input_datetime'
				}
			}, {
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			},{
				type: 'text',
				label: 'Nama Pengirim',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'trx_payment_bank_from_bank_account_name'
				}
			}, {
				type: 'text',
				label: 'Nama Penerima',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'trx_payment_bank_to_bank_account_name'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceTransaction', ['listData', 'paginationData', 'listStatus']),
	},
	methods: {
		...mapActions('ecommerceTransaction', ['getBankTransfer', 'getBankTransferCancel', 'exportBankTransfer', 'exportBankTransferCancel', 'approvalTransfer', 'cancelApprovalTransfer']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceTransaction', ['clearDataTransaction']),

		getData() {
			if (this.$route.name == 'ecommerce-transfer-confirmation') {
				let params = [...this.params, {
					value: '1',
					comparison: '=',
					type: 'string',
					field: 'trx_payment_bank_status'
				}]
				this.getBankTransfer(this.queryString({limit:this.limit, page: this.page, params: params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'ecommerce-transfer-confirmation-cancel') {
				this.getBankTransferCancel(this.queryString({limit:this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			if (this.$route.name == 'ecommerce-transfer-confirmation') {
				let params = [...this.params, {
					value: '1',
					comparison: '=',
					type: 'string',
					field: 'trx_payment_bank_status'
				}]
				this.exportBankTransfer(this.queryString({params: params, sort: this.sortBy, dir: this.sortDir}))
			} else if (this.$route.name == 'ecommerce-transfer-confirmation-cancel') {
				this.exportBankTransferCancel(this.queryString({params: this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async approve(trx_id) {
			this.trx_id = trx_id
			await this.$refs.ModalApprovalTransfer.showModal()
		},
		async approval(params) {
			params.trx_id = await this.trx_id
			let result = await this.approvalTransfer(params)
			if (result == true)
				await this.$refs.ModalApprovalTransfer.hideModal()
			await this.getData()
			this.trx_id = await ''
		},
		cancelTransfer(trx_id) {
			this.trx_id = trx_id
			this.$refs.modalconfirmTransfer.setMessage('Apakah anda yakin ingin memproses pembatalan transfer')
			this.$refs.modalconfirmTransfer.showConfirm()
		},
		async confirmCancelTransfer() {
			let result = await this.cancelApprovalTransfer({
				trx_id: this.trx_id
			})
			if (result == true)
				await this.$refs.modalconfirmTransfer.hideConfirm()
			await this.getData()
			this.trx_id = await ''
		}
	},
	beforeDestroy(){
		this.clearDataTransaction()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Transaction Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>
